import { useEffect, useState, useMemo } from "react";
import AppointmentCalendarView from "./AppointmentCalendarView";
import TableView from "./TableView";
import NewTabs from "../../../Component/DigitalMarketing/NewTabs";
import { useGetAllNewAppointmentsQuery } from "../../../Service/appoinment";
import NewAppoinment from "../Appoinment/NewAppointments/NewAppoinments";
import { useDispatch, useSelector } from "react-redux";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import Loader from "../../../Component/DigitalMarketing/Loader";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import { Col, Row } from "react-bootstrap";
import NewDateRangePicker from "../../../Component/DigitalMarketing/Forms/NewDateRangePicker";
import moment from "moment";

const Appointment = () => {
  const dispatch = useDispatch();
  const { roleName } = useSelector((state: any) => state.auth);

  const [showAppointment, setShowAppointment] = useState(false);
  const [active, setActive] = useState(2);
  const [pagination, setPagination] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [date, setDate] = useState({ startDate: "", endDate: "" });

  // ✅ Build query params safely using useMemo
  const pagi = useMemo(
    () => ({
      pageNo: pagination,
      size: 5,
      name: searchValue?.trim() || "",
      scheduleDate: date?.startDate || "",
      reScheduleDate: date?.endDate || "",
    }),
    [pagination, searchValue, date]
  );

  const { data, refetch, isLoading } = useGetAllNewAppointmentsQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });

  const onChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  const onHandleChange = (value: [Date | null, Date | null]) => {
    if (value?.[0] && value?.[1]) {
      setDate({
        startDate: moment(value[0]).format("YYYY-MM-DD"),
        endDate: moment(value[1]).format("YYYY-MM-DD"),
      });
    } else {
      setDate({ startDate: "", endDate: "" });
    }
    setDateRange(value);
  };

  const values = [
    { id: 1, name: "calendar_month" },
    { id: 2, name: "table_rows" },
  ];

  useEffect(() => {
    const data: any = {
      first: "Appointments",
    };
    dispatch(Change(data));
  }, [dispatch]);

  // ✅ Refetch when filters or pagination change
  useEffect(() => {
    refetch();
  }, [refetch, pagination, searchValue, date]);

  if (isLoading) {
    return <Loader loading={true} />;
  }

  return (
    <>
      {active === 2 && (
        <Row className="mb-3 align-items-center">
          <Col md={5}>
            <SearchBox value={searchValue} onChange={onChangeSearch} />
          </Col>
          <Col md={5}>
            <NewDateRangePicker
              value={dateRange}
              onChange={onHandleChange}
              disableFutureDates={true}
            />
          </Col>
        </Row>
      )}

      <div>
        {(roleName === "branch" || roleName === "receptionist") && (
          <div className="d-flex justify-content-end mb-3">
            <button
              type="button"
              className="btn btn-violet"
              onClick={() => setShowAppointment(true)}
            >
              Book Appointment
            </button>
          </div>
        )}

        <div className="d-flex justify-content-end mb-3">
          <NewTabs tabIconList={values} active={active} setActive={setActive} />
        </div>

        {active === 1 && <AppointmentCalendarView />}
        {active === 2 && <TableView data={data?.data} />}

        <NewAppoinment
          showAppointment={showAppointment}
          setShowAppointment={setShowAppointment}
          refetch={refetch}
        />
      </div>

      <Pagination
        setpagination={setPagination}
        pagination={pagination}
        data={data}
      />
    </>
  );
};

export default Appointment;
